<template>
  <div name="activityReport">

  <section class=" w-full mx-auto px-6 pb-6 " >
       <h4 class="panel-header font-semibold">Pupils Participating in Extra Curricular</h4>
      
        <div v-if="componentLoaded">
                <div class="grid grid-cols-1 w-full mx-auto text-center bg-gray-100 rounded-lg" >
                  <h5 class="font-bold ml-2">Number of clubs pupils attend</h5>

                    <barChart :data-source="reppingActivityVisit" ></barChart>
                </div>

                    <div class="grid grid-cols-2 gap-4 mt-4 ">

                    <div class="bg-gray-100 rounded-lg p-4">

                        <donutChart  :data-source="reppingActivity" :chart-title="'In an activity'"></donutChart>
                    </div>


                    <div class="bg-gray-100 rounded-lg p-4">
                 
                         <donutChart  :data-source="reppingActivityAtTimeFrame" :totalOveride="activities.length" :chart-title="'At timeframes'"></donutChart>
                    </div>

                  </div>
                </div>

                   <p class="empty" v-else>We could not find any data for your given selection.</p>
                </section>

                <div class="html2pdf__page-break">&nbsp;</div>
  <section class=" w-full mx-auto px-6 pb-6 pt-4 mb-8 " >
       <h4 class="panel-header font-semibold mb-2">Activities in Extra Curricular</h4>

            <div class="y-space-4" v-if="componentLoaded">

                    <div class="grid grid-cols-2 gap-4 " >

                      <div class="bg-gray-100 rounded-lg p-4">
                         <donutChart :data-source="timeFrameChartData" :totalOveride="activities.length" :chart-title="'By time frame'"></donutChart>
                    </div>

                    <div class="bg-gray-100 rounded-lg p-4">
                         <donutChart :data-source="typeChartData" :totalOveride="activities.length"  :chart-title="'By type'"></donutChart>
                      </div>

                  </div>

                  <div class="grid grid-cols-1 w-11/12 mx-auto text-center bg-gray-100 rounded-lg mt-8 " >
                  <h5 class="font-bold mt-3 text-xs mb-2 ml-2">Clubs per term</h5>
                    <barChart :data-source="reppingActivityTerms" ></barChart>

                </div>
              </div>
                  

                   <p class="empty" v-else>We could not find any data for your given selection.</p>
                </section>

  </div>
</template>

<script>
const donutChart = () => import("@/components/charts/DonutChart.vue");
const barChart = () => import("@/components/charts/BarChart.vue");
import { termList } from "@/assets/js/utils";

const visitParams = [
  {low: 1, high: 5, title: "1-5"},
  {low: 6, high: 10, title: "6-10"},
  {low: 11, high: 15, title: "11-15"},
  {low: 16, high: 20, title: "16-20"},
  {low: 21, high: 25, title: "21-25"},
  {low: 26, high: 30, title: "26-30"},
  {low: 31, high: 3000, title: "31+"}
]

export default {
  name: "activityReport",
    props: {
      pupilCount: {type: Number, required: true},
      activities: {type: Array, required: true},
  },
  computed: {
    componentLoaded() {
      return this.activities.length > 0;
    },
    reppingActivityVisit() {
      let vm = this
      var registers = vm.activities.flatMap(function(a) {
        if (a.pupils != undefined) {
            return a.pupils.map(r => r.pupil_identifier).length
        }
      });

      var results = visitParams.map(function(param) {
        let count = registers.reduce(function(acc, val) { 
        if (val === undefined) { return acc }

          if (val >= param.low && val < param.high) {
           return acc + 1
          } else {
            return acc
          }

        }, 0)

        return { "name": param.title, "value": count, "color": "#A3E9D2" }
      })

      return results
    },
    reppingActivity() {
      if (!this.componentLoaded) {
        return null;
      }

      let unique = this.uniqueRepping();

      return [
        { name: "Attending", value: unique, color: "#A3E9D2" },
        {
          name: "Non-attending",
          value: this.pupilCount - unique,
          color: "#FBB3B3"
        }
      ];
    },
    reppingActivityAtTimeFrame() {
      if (!this.componentLoaded) {
        return null;
      }

      var list = this.activities.filter(function(row) {
        let filtered = true;
           if (row.pupils != undefined) {
          filtered = row.pupils.length > 0;
        }

        return filtered;
      });

      let data = this.timeFrames.map(timeframe => {
        var filtered = list.filter(activity => {
          let filtered = true;
          filtered = activity.timeframe.includes(timeframe.value);
          return filtered;
        });

        let repping = filtered.flatMap(function(activity) {
          let pupils =  activity.pupils != undefined ?  activity.pupils : []
          return pupils.map(function(reg) {
            return reg.pupil_identifier;
          });
        });

        //let unique = Array.from(new Set(repping)).length;
        let unique = Array.from(repping).length;

        return { name: timeframe.title, value: unique, color: timeframe.color };
      });

      return data;
    },
    timeFrameChartData() {
      if (!this.componentLoaded) {
        return null;
      }

      let activityList = this.activities;
      let data = this.timeFrames.map(timeframe => {
        var list = activityList.filter(activity => {
          let filtered = true;
          filtered = activity.timeframe.includes(timeframe.value);
          return filtered;
        });

        return {
          name: timeframe.title,
          value: list.length,
          color: timeframe.color
        };
      });

      return data;
    },
    typeChartData() {
      if (!this.componentLoaded) {
        return null;
      }

      return [
        {
          name: "Other",
          value: this.getCountByProgramType("other"),
          color: "#EBEBEB"
        },
        {
          name: "CPD",
          value: this.getCountByProgramType("cpd"),
          color: "#FFEAAA"
        },
        {
          name: "Swimming",
          value: this.getCountByProgramType("swimming"),
          color: "#A7C2FF"
        },
        {
          name: "Health",
          value: this.getCountByProgramType("health"),
          color: "#A3E9D2"
        },
        {
          name: "PE",
          value: this.getCountByProgramType("education"),
          color: "#FBB3B3"
        }
      ];
    },
    reppingActivityTerms() {
      let vm = this
      let results = vm.terms.map(term => {
        const count = vm.activities.reduce(function(acc, current) {
          let selectedTerms = current.term.split(",")
          return selectedTerms.includes(term.key) ? ++acc : acc
        }, 0)


        return { "name": term.name, "value": count, "color": "#A3E9D2" }
      })

      return results
    },
  },
  data() {
    return {
      terms: termList(),
      timeFrames: [
        { value: "breakfast", title: "Breakfast", color: "#A3E9D2" },
        { value: "lunch", title: "Lunch", color: "#FFEAAA" },
        { value: "after-school", title: "After School", color: "#A7C2FF" }
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {
    getCountByProgramType(type) {
      var list = this.activities.filter(activity => {
        let filtered = true;
        let sessionType =  activity.session_type != null ? activity.session_type : "" 
  
        if (type == "education") {
          filtered =
            sessionType === type ||
            sessionType.length < 1;
        } else {
          filtered = sessionType === type;
        }

        return filtered;
      });

      return list.length;
    },
    uniqueRepping() {
      let list = this.activities.filter(activity => {
        let filtered = true;
        if (activity.pupils != undefined) {
          filtered = activity.pupils.length > 0;
        }
  
        return filtered;
      });

     

      let repping = list.flatMap(activity => {
        console.log("fil", JSON.stringify(activity.pupils))
        let pupils = activity.pupils != undefined ? activity.pupils : []
        console.log("pp", JSON.stringify(pupils))
        return pupils.map(reg => {
          return reg.pupil_identifier;
        });
      });

      console.log("fil", JSON.stringify(repping))
      return Array.from(new Set(repping)).length;
    }
  },
  components: {
    donutChart,
    barChart
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main .inner section.filter h4 {
  margin-bottom: 0px !important;
}

.upper {
  text-transform: uppercase;
}

.smaller {
  font-size: 75% !important;
}
</style>
